/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.18.1.0 (NJsonSchema v9.10.66.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { BaseClient } from './BaseClient';

export interface IAccountInformationClient {
    updateAccountInfo(request: UpdateCustomerInfoRequest | null): Promise<AccountSettings | null>;
    suggest(search: string | null): Promise<AddressSuggestion[] | null>;
    validateAddress2(request: AddressValidationRequest | null): Promise<ValidateAddressResponseDto | null>;
    /**
     * @return Address is valid
     */
    validateAddress(validateAddress: ValidateAddressRequest | null): Promise<void>;
}

export class AccountInformationClient extends BaseClient implements IAccountInformationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    updateAccountInfo(request: UpdateCustomerInfoRequest | null): Promise<AccountSettings | null> {
        let url_ = this.baseUrl + "/account/information/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAccountInfo(_response));
        });
    }

    protected processUpdateAccountInfo(response: Response): Promise<AccountSettings | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings | null>(<any>null);
    }

    suggest(search: string | null): Promise<AddressSuggestion[] | null> {
        let url_ = this.baseUrl + "/account/information/address/suggest?";
        if (search === undefined)
            throw new Error("The parameter 'search' must be defined.");
        else
            url_ += "search=" + encodeURIComponent("" + search) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSuggest(_response));
        });
    }

    protected processSuggest(response: Response): Promise<AddressSuggestion[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddressSuggestion[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressSuggestion[] | null>(<any>null);
    }

    validateAddress2(request: AddressValidationRequest | null): Promise<ValidateAddressResponseDto | null> {
        let url_ = this.baseUrl + "/account/information/address/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateAddress2(_response));
        });
    }

    protected processValidateAddress2(response: Response): Promise<ValidateAddressResponseDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ValidateAddressResponseDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ValidateAddressResponseDto>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateAddressResponseDto | null>(<any>null);
    }

    /**
     * @return Address is valid
     */
    validateAddress(validateAddress: ValidateAddressRequest | null): Promise<void> {
        let url_ = this.baseUrl + "/account/information/address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(validateAddress);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateAddress(_response));
        });
    }

    protected processValidateAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export interface IAccountSettingClient {
    getPageModel(): Promise<AccountSettings | null>;
}

export class AccountSettingClient extends BaseClient implements IAccountSettingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    getPageModel(): Promise<AccountSettings | null> {
        let url_ = this.baseUrl + "/account/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPageModel(_response));
        });
    }

    protected processGetPageModel(response: Response): Promise<AccountSettings | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings | null>(<any>null);
    }
}

export interface ICancelSubscriptionClient {
    getPageModel(subscriptionId: number): Promise<CancelSubscriptionModel | null>;
}

export class CancelSubscriptionClient extends BaseClient implements ICancelSubscriptionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    getPageModel(subscriptionId: number): Promise<CancelSubscriptionModel | null> {
        let url_ = this.baseUrl + "/account/cancel?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPageModel(_response));
        });
    }

    protected processGetPageModel(response: Response): Promise<CancelSubscriptionModel | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CancelSubscriptionModel>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancelSubscriptionModel | null>(<any>null);
    }
}

export interface IPaymentClient {
    addNewCard(): Promise<string | null>;
    payNow(deliveryId: number, enableRebilling: boolean, useDefaultCard: boolean): Promise<string | null>;
    removeCreditCard(id: number): Promise<AccountSettings | null>;
    setCreditCardAsDefault(id: number): Promise<AccountSettings | null>;
}

export class PaymentClient extends BaseClient implements IPaymentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    addNewCard(): Promise<string | null> {
        let url_ = this.baseUrl + "/account/payment/card/add";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddNewCard(_response));
        });
    }

    protected processAddNewCard(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    payNow(deliveryId: number, enableRebilling: boolean, useDefaultCard: boolean): Promise<string | null> {
        let url_ = this.baseUrl + "/account/payment/paynow?";
        if (deliveryId === undefined || deliveryId === null)
            throw new Error("The parameter 'deliveryId' must be defined and cannot be null.");
        else
            url_ += "deliveryId=" + encodeURIComponent("" + deliveryId) + "&"; 
        if (enableRebilling === undefined || enableRebilling === null)
            throw new Error("The parameter 'enableRebilling' must be defined and cannot be null.");
        else
            url_ += "enableRebilling=" + encodeURIComponent("" + enableRebilling) + "&"; 
        if (useDefaultCard === undefined || useDefaultCard === null)
            throw new Error("The parameter 'useDefaultCard' must be defined and cannot be null.");
        else
            url_ += "useDefaultCard=" + encodeURIComponent("" + useDefaultCard) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPayNow(_response));
        });
    }

    protected processPayNow(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    removeCreditCard(id: number): Promise<AccountSettings | null> {
        let url_ = this.baseUrl + "/account/payment/card/remove?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveCreditCard(_response));
        });
    }

    protected processRemoveCreditCard(response: Response): Promise<AccountSettings | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings | null>(<any>null);
    }

    setCreditCardAsDefault(id: number): Promise<AccountSettings | null> {
        let url_ = this.baseUrl + "/account/payment/card/default?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetCreditCardAsDefault(_response));
        });
    }

    protected processSetCreditCardAsDefault(response: Response): Promise<AccountSettings | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings | null>(<any>null);
    }
}

export interface ISubscriptionClient {
    getSubscriptions(): Promise<SubscriptionDTO[] | null>;
    createSubscription(request: CreateSubscriptionRequest | null): Promise<AccountSettings | null>;
    /**
     * @return OK
     */
    createSubscriptionAsyncV2(request: AccountCreateSubscriptionRequestBody | null): Promise<string | null>;
    /**
     * @return OK
     */
    validatePromoCode(sku: string, code: string): Promise<CodeValidationResponse | null>;
    /**
     * @return OK
     */
    upcomingWeek(): Promise<Date>;
    /**
     * @return OK
     */
    getProductDetailsForSkuAndWeek(sku: string, week: string, promoCode: string | null): Promise<ProductAndRecipeDetailsResponse | null>;
    recipes(payload: RecipeBagDisplayPayload | null): Promise<RecipesForWeek | null>;
    updateSubscription(update: UpdateSubscriptionRequest | null): Promise<AccountSettings | null>;
    cancelSubscription(request: CancelSubscriptionRequest | null): Promise<AccountSettings | null>;
    /**
     * @return OK
     */
    cancelSubscriptionAsyncV2(subscriptionNumber: string | null, request: AccountCancelSubscriptionRequestBody | null): Promise<CancelSubscriptionResponse | null>;
    restartSubscription(subscriptionId: number): Promise<AccountSettings | null>;
    deliveryDates(productOptionId: number): Promise<DeliveryDate[] | null>;
    deliverySlots(productOptionId: number, pafId: number | null | undefined): Promise<DeliverySlot[] | null>;
    getCustomerMessages(triggerCode: string | null, subscriptionNumber: string | null, deliveryDateId: string | null): Promise<GetCustomerMessageResponse | null>;
    applyPromoCode(request: ApplyPromoCodeRequest | null): Promise<AccountSettings | null>;
    /**
     * @return OK
     */
    updateSubscriptionV2(subscriptionNumber: string, request: AccountUpdateSubscriptionRequestBody | null): Promise<string | null>;
    /**
     * @return OK
     */
    subscriptionPlanYourWeekUpdate(subscriptionNumber: string, week: string, request: AccountUpdatePlanYourWeekRequestBody | null): Promise<AccountUpdatePlanYourWeekResponse | null>;
    validateSubscriptionChange(subscriptionNumber: string, request: AccountValidateProductChangeRequestBody | null): Promise<AccountValidateProductChangeResponse | null>;
}

export class SubscriptionClient extends BaseClient implements ISubscriptionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    getSubscriptions(): Promise<SubscriptionDTO[] | null> {
        let url_ = this.baseUrl + "/account/subscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubscriptions(_response));
        });
    }

    protected processGetSubscriptions(response: Response): Promise<SubscriptionDTO[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SubscriptionDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionDTO[] | null>(<any>null);
    }

    createSubscription(request: CreateSubscriptionRequest | null): Promise<AccountSettings | null> {
        let url_ = this.baseUrl + "/account/subscription/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSubscription(_response));
        });
    }

    protected processCreateSubscription(response: Response): Promise<AccountSettings | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings | null>(<any>null);
    }

    /**
     * @return OK
     */
    createSubscriptionAsyncV2(request: AccountCreateSubscriptionRequestBody | null): Promise<string | null> {
        let url_ = this.baseUrl + "/account/subscription/createV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSubscriptionAsyncV2(_response));
        });
    }

    protected processCreateSubscriptionAsyncV2(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    /**
     * @return OK
     */
    validatePromoCode(sku: string, code: string): Promise<CodeValidationResponse | null> {
        let url_ = this.baseUrl + "/account/subscription/validateCode/{code}/{sku}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidatePromoCode(_response));
        });
    }

    protected processValidatePromoCode(response: Response): Promise<CodeValidationResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CodeValidationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeValidationResponse | null>(<any>null);
    }

    /**
     * @return OK
     */
    upcomingWeek(): Promise<Date> {
        let url_ = this.baseUrl + "/account/subscription/upcomingWeek";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpcomingWeek(_response));
        });
    }

    protected processUpcomingWeek(response: Response): Promise<Date> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Date>(<any>null);
    }

    /**
     * @return OK
     */
    getProductDetailsForSkuAndWeek(sku: string, week: string, promoCode: string | null): Promise<ProductAndRecipeDetailsResponse | null> {
        let url_ = this.baseUrl + "/account/subscription/products/{sku}/week/{week}?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent("" + week)); 
        if (promoCode === undefined)
            throw new Error("The parameter 'promoCode' must be defined.");
        else
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProductDetailsForSkuAndWeek(_response));
        });
    }

    protected processGetProductDetailsForSkuAndWeek(response: Response): Promise<ProductAndRecipeDetailsResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductAndRecipeDetailsResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductAndRecipeDetailsResponse | null>(<any>null);
    }

    recipes(payload: RecipeBagDisplayPayload | null): Promise<RecipesForWeek | null> {
        let url_ = this.baseUrl + "/account/subscription/recipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRecipes(_response));
        });
    }

    protected processRecipes(response: Response): Promise<RecipesForWeek | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipesForWeek>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipesForWeek | null>(<any>null);
    }

    updateSubscription(update: UpdateSubscriptionRequest | null): Promise<AccountSettings | null> {
        let url_ = this.baseUrl + "/account/subscription/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(update);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSubscription(_response));
        });
    }

    protected processUpdateSubscription(response: Response): Promise<AccountSettings | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings | null>(<any>null);
    }

    cancelSubscription(request: CancelSubscriptionRequest | null): Promise<AccountSettings | null> {
        let url_ = this.baseUrl + "/account/subscription/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancelSubscription(_response));
        });
    }

    protected processCancelSubscription(response: Response): Promise<AccountSettings | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings | null>(<any>null);
    }

    /**
     * @return OK
     */
    cancelSubscriptionAsyncV2(subscriptionNumber: string | null, request: AccountCancelSubscriptionRequestBody | null): Promise<CancelSubscriptionResponse | null> {
        let url_ = this.baseUrl + "/account/subscription/cancelV2?";
        if (subscriptionNumber === undefined)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        else
            url_ += "subscriptionNumber=" + encodeURIComponent("" + subscriptionNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancelSubscriptionAsyncV2(_response));
        });
    }

    protected processCancelSubscriptionAsyncV2(response: Response): Promise<CancelSubscriptionResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CancelSubscriptionResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancelSubscriptionResponse | null>(<any>null);
    }

    restartSubscription(subscriptionId: number): Promise<AccountSettings | null> {
        let url_ = this.baseUrl + "/account/subscription/restart?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestartSubscription(_response));
        });
    }

    protected processRestartSubscription(response: Response): Promise<AccountSettings | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings | null>(<any>null);
    }

    deliveryDates(productOptionId: number): Promise<DeliveryDate[] | null> {
        let url_ = this.baseUrl + "/account/subscription/deliverydates?";
        if (productOptionId === undefined || productOptionId === null)
            throw new Error("The parameter 'productOptionId' must be defined and cannot be null.");
        else
            url_ += "productOptionId=" + encodeURIComponent("" + productOptionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeliveryDates(_response));
        });
    }

    protected processDeliveryDates(response: Response): Promise<DeliveryDate[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DeliveryDate[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliveryDate[] | null>(<any>null);
    }

    deliverySlots(productOptionId: number, pafId: number | null | undefined): Promise<DeliverySlot[] | null> {
        let url_ = this.baseUrl + "/account/subscription/deliveryslots?";
        if (productOptionId === undefined || productOptionId === null)
            throw new Error("The parameter 'productOptionId' must be defined and cannot be null.");
        else
            url_ += "productOptionId=" + encodeURIComponent("" + productOptionId) + "&"; 
        if (pafId !== undefined)
            url_ += "pafId=" + encodeURIComponent("" + pafId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeliverySlots(_response));
        });
    }

    protected processDeliverySlots(response: Response): Promise<DeliverySlot[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DeliverySlot[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliverySlot[] | null>(<any>null);
    }

    getCustomerMessages(triggerCode: string | null, subscriptionNumber: string | null, deliveryDateId: string | null): Promise<GetCustomerMessageResponse | null> {
        let url_ = this.baseUrl + "/account/subscription/customerMessages?";
        if (triggerCode === undefined)
            throw new Error("The parameter 'triggerCode' must be defined.");
        else
            url_ += "triggerCode=" + encodeURIComponent("" + triggerCode) + "&"; 
        if (subscriptionNumber === undefined)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        else
            url_ += "subscriptionNumber=" + encodeURIComponent("" + subscriptionNumber) + "&"; 
        if (deliveryDateId === undefined)
            throw new Error("The parameter 'deliveryDateId' must be defined.");
        else
            url_ += "deliveryDateId=" + encodeURIComponent("" + deliveryDateId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomerMessages(_response));
        });
    }

    protected processGetCustomerMessages(response: Response): Promise<GetCustomerMessageResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetCustomerMessageResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCustomerMessageResponse | null>(<any>null);
    }

    applyPromoCode(request: ApplyPromoCodeRequest | null): Promise<AccountSettings | null> {
        let url_ = this.baseUrl + "/account/subscription/applypromo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApplyPromoCode(_response));
        });
    }

    protected processApplyPromoCode(response: Response): Promise<AccountSettings | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <any>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings | null>(<any>null);
    }

    /**
     * @return OK
     */
    updateSubscriptionV2(subscriptionNumber: string, request: AccountUpdateSubscriptionRequestBody | null): Promise<string | null> {
        let url_ = this.baseUrl + "/account/subscription/updateV2/{subscriptionNumber}";
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSubscriptionV2(_response));
        });
    }

    protected processUpdateSubscriptionV2(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    /**
     * @return OK
     */
    subscriptionPlanYourWeekUpdate(subscriptionNumber: string, week: string, request: AccountUpdatePlanYourWeekRequestBody | null): Promise<AccountUpdatePlanYourWeekResponse | null> {
        let url_ = this.baseUrl + "/account/subscription/planYourWeekUpdate/{subscriptionNumber}/{week}";
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber)); 
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent("" + week)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubscriptionPlanYourWeekUpdate(_response));
        });
    }

    protected processSubscriptionPlanYourWeekUpdate(response: Response): Promise<AccountUpdatePlanYourWeekResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountUpdatePlanYourWeekResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountUpdatePlanYourWeekResponse | null>(<any>null);
    }

    validateSubscriptionChange(subscriptionNumber: string, request: AccountValidateProductChangeRequestBody | null): Promise<AccountValidateProductChangeResponse | null> {
        let url_ = this.baseUrl + "/account/subscription/validate/{subscriptionNumber}";
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateSubscriptionChange(_response));
        });
    }

    protected processValidateSubscriptionChange(response: Response): Promise<AccountValidateProductChangeResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountValidateProductChangeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountValidateProductChangeResponse | null>(<any>null);
    }
}

export interface IVoucherClient {
    redeemVoucherCode(request: RedeemVoucherRequest | null): Promise<AccountSettings | null>;
}

export class VoucherClient extends BaseClient implements IVoucherClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    redeemVoucherCode(request: RedeemVoucherRequest | null): Promise<AccountSettings | null> {
        let url_ = this.baseUrl + "/account/voucher/redeem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRedeemVoucherCode(_response));
        });
    }

    protected processRedeemVoucherCode(response: Response): Promise<AccountSettings | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettings>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettings | null>(<any>null);
    }
}

export interface ICustomerClient {
    customerInformation(): Promise<CustomerResponse | null>;
    getCustomerNumber(): Promise<string | null>;
    getCustomerProfile(): Promise<CustomerProfileResponse | null>;
}

export class CustomerClient extends BaseClient implements ICustomerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    customerInformation(): Promise<CustomerResponse | null> {
        let url_ = this.baseUrl + "/account/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCustomerInformation(_response));
        });
    }

    protected processCustomerInformation(response: Response): Promise<CustomerResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerResponse | null>(<any>null);
    }

    getCustomerNumber(): Promise<string | null> {
        let url_ = this.baseUrl + "/account/me/customerNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomerNumber(_response));
        });
    }

    protected processGetCustomerNumber(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    getCustomerProfile(): Promise<CustomerProfileResponse | null> {
        let url_ = this.baseUrl + "/account/me/customerProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomerProfile(_response));
        });
    }

    protected processGetCustomerProfile(response: Response): Promise<CustomerProfileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerProfileResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerProfileResponse | null>(<any>null);
    }
}

export interface ICalendarClient {
    calendar(): Promise<CalendarResponse | null>;
    skipDelivery(week: Week): Promise<CalendarResponse | null>;
    unSkipDelivery(week: Week): Promise<CalendarResponse | null>;
}

export class CalendarClient extends BaseClient implements ICalendarClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    calendar(): Promise<CalendarResponse | null> {
        let url_ = this.baseUrl + "/account/calendar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCalendar(_response));
        });
    }

    protected processCalendar(response: Response): Promise<CalendarResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CalendarResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarResponse | null>(<any>null);
    }

    skipDelivery(week: Week): Promise<CalendarResponse | null> {
        let url_ = this.baseUrl + "/account/calendar/skipdelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(week);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSkipDelivery(_response));
        });
    }

    protected processSkipDelivery(response: Response): Promise<CalendarResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <CalendarResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CalendarResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarResponse | null>(<any>null);
    }

    unSkipDelivery(week: Week): Promise<CalendarResponse | null> {
        let url_ = this.baseUrl + "/account/calendar/unskipdelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(week);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnSkipDelivery(_response));
        });
    }

    protected processUnSkipDelivery(response: Response): Promise<CalendarResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <CalendarResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CalendarResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarResponse | null>(<any>null);
    }
}

export interface IDeliveryClient {
    deliverySlots(deliveryId: number, pafId: number | null | undefined): Promise<DeliverySlot[] | null>;
    updateDelivery(request: UpdateDeliveryRequest | null): Promise<UpdateDeliveryResponse | null>;
    updateSubscription(request: UpdateDeliveryRequest | null): Promise<DeliveryResponse | null>;
}

export class DeliveryClient extends BaseClient implements IDeliveryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    deliverySlots(deliveryId: number, pafId: number | null | undefined): Promise<DeliverySlot[] | null> {
        let url_ = this.baseUrl + "/account/delivery/deliveryslots?";
        if (deliveryId === undefined || deliveryId === null)
            throw new Error("The parameter 'deliveryId' must be defined and cannot be null.");
        else
            url_ += "deliveryId=" + encodeURIComponent("" + deliveryId) + "&"; 
        if (pafId !== undefined)
            url_ += "pafId=" + encodeURIComponent("" + pafId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeliverySlots(_response));
        });
    }

    protected processDeliverySlots(response: Response): Promise<DeliverySlot[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DeliverySlot[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliverySlot[] | null>(<any>null);
    }

    updateDelivery(request: UpdateDeliveryRequest | null): Promise<UpdateDeliveryResponse | null> {
        let url_ = this.baseUrl + "/account/delivery/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDelivery(_response));
        });
    }

    protected processUpdateDelivery(response: Response): Promise<UpdateDeliveryResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <UpdateDeliveryResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UpdateDeliveryResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateDeliveryResponse | null>(<any>null);
    }

    updateSubscription(request: UpdateDeliveryRequest | null): Promise<DeliveryResponse | null> {
        let url_ = this.baseUrl + "/account/delivery/update/subscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSubscription(_response));
        });
    }

    protected processUpdateSubscription(response: Response): Promise<DeliveryResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <DeliveryResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DeliveryResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeliveryResponse | null>(<any>null);
    }
}

export interface IExtraClient {
    subscriptionExtras(subscriptionId: number): Promise<ExtraResponse | null>;
    getAvailableExtrasBySku(sku: string, week: string | null, promoCode: string | null | undefined): Promise<AvailableExtrasResponse | null>;
    update(request: UpdateExtraRequest | null): Promise<ExtraResponse | null>;
    add(request: AddExtraRequest | null): Promise<ExtraResponse | null>;
    addOrUpdate(sku: string | null, subscriptionId: number): Promise<void>;
    remove(request: RemoveExtraRequest | null): Promise<ExtraResponse | null>;
    getExtrasContent(): Promise<ProductGroup[] | null>;
    getExtraPageContentBySlug(request: ExtraContentRequest | null): Promise<ProductGroup | null>;
    getExtraSuggestionsByBagSku(sku: string, week: string): Promise<AccountProductSummary[] | null>;
    getExtraDetail(sku: string, week: string, promoCode: string | null | undefined): Promise<ExtraDetailResponse | null>;
}

export class ExtraClient extends BaseClient implements IExtraClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    subscriptionExtras(subscriptionId: number): Promise<ExtraResponse | null> {
        let url_ = this.baseUrl + "/extras/subscription/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubscriptionExtras(_response));
        });
    }

    protected processSubscriptionExtras(response: Response): Promise<ExtraResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ExtraResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtraResponse | null>(<any>null);
    }

    getAvailableExtrasBySku(sku: string, week: string | null, promoCode: string | null | undefined): Promise<AvailableExtrasResponse | null> {
        let url_ = this.baseUrl + "/extras/bag/{sku}/extras/available?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        if (week === undefined)
            throw new Error("The parameter 'week' must be defined.");
        else
            url_ += "week=" + encodeURIComponent("" + week) + "&"; 
        if (promoCode !== undefined)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableExtrasBySku(_response));
        });
    }

    protected processGetAvailableExtrasBySku(response: Response): Promise<AvailableExtrasResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AvailableExtrasResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableExtrasResponse | null>(<any>null);
    }

    update(request: UpdateExtraRequest | null): Promise<ExtraResponse | null> {
        let url_ = this.baseUrl + "/extras/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ExtraResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ExtraResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ExtraResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtraResponse | null>(<any>null);
    }

    add(request: AddExtraRequest | null): Promise<ExtraResponse | null> {
        let url_ = this.baseUrl + "/extras/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<ExtraResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ExtraResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ExtraResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtraResponse | null>(<any>null);
    }

    addOrUpdate(sku: string | null, subscriptionId: number): Promise<void> {
        let url_ = this.baseUrl + "/extras/addOrUpdate?";
        if (sku === undefined)
            throw new Error("The parameter 'sku' must be defined.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&"; 
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddOrUpdate(_response));
        });
    }

    protected processAddOrUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    remove(request: RemoveExtraRequest | null): Promise<ExtraResponse | null> {
        let url_ = this.baseUrl + "/extras/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemove(_response));
        });
    }

    protected processRemove(response: Response): Promise<ExtraResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ExtraResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtraResponse | null>(<any>null);
    }

    getExtrasContent(): Promise<ProductGroup[] | null> {
        let url_ = this.baseUrl + "/extras";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExtrasContent(_response));
        });
    }

    protected processGetExtrasContent(response: Response): Promise<ProductGroup[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductGroup[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductGroup[] | null>(<any>null);
    }

    getExtraPageContentBySlug(request: ExtraContentRequest | null): Promise<ProductGroup | null> {
        let url_ = this.baseUrl + "/extras/content";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExtraPageContentBySlug(_response));
        });
    }

    protected processGetExtraPageContentBySlug(response: Response): Promise<ProductGroup | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductGroup>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductGroup | null>(<any>null);
    }

    getExtraSuggestionsByBagSku(sku: string, week: string): Promise<AccountProductSummary[] | null> {
        let url_ = this.baseUrl + "/extras/getExtraSuggestionsByBag/{sku}/{week}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent("" + week)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExtraSuggestionsByBagSku(_response));
        });
    }

    protected processGetExtraSuggestionsByBagSku(response: Response): Promise<AccountProductSummary[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountProductSummary[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountProductSummary[] | null>(<any>null);
    }

    getExtraDetail(sku: string, week: string, promoCode: string | null | undefined): Promise<ExtraDetailResponse | null> {
        let url_ = this.baseUrl + "/extras/details/{sku}/{week}?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent("" + week)); 
        if (promoCode !== undefined)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExtraDetail(_response));
        });
    }

    protected processGetExtraDetail(response: Response): Promise<ExtraDetailResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ExtraDetailResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtraDetailResponse | null>(<any>null);
    }
}

export interface IOrderAccountClient {
    myOrdersV2(): Promise<OrderWithRecipesAndExtras[] | null>;
    singularSalesOrderForecast(targetWeek: Date, subscriptionNumber: string | null, promoCode: string | null | undefined): Promise<SingleOrderWithRecipesAndExtras | null>;
    skipDelivery(request: SkipDeliveryRequest | null): Promise<LegacyOrdersResponse | null>;
    unSkipDelivery(subscriptionId: number, week: Week): Promise<LegacyOrdersResponse | null>;
    saveRecipeSelection(request: SaveRecipeSelectionRequest | null): Promise<RecipeSelectionResponse | null>;
    /**
     * @return OK
     */
    getSubscriptionCostPreview(week: Date, request: CostPreviewRequestBody | null): Promise<CostPreviewResponse | null>;
    getLegacySubscriptionState(): Promise<LegacyOrdersPageStates | null>;
    getAddExtraLinks(): Promise<AddExtraLink[] | null>;
    /**
     * @return OK
     */
    getProductsGroupedForMarketing(): Promise<ProductGroupResponse[] | null>;
    /**
     * @return OK
     */
    getFilters(productSku: string | null, week: Date): Promise<FiltersResponse | null>;
}

export class OrderAccountClient extends BaseClient implements IOrderAccountClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    myOrdersV2(): Promise<OrderWithRecipesAndExtras[] | null> {
        let url_ = this.baseUrl + "/account/orders/orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMyOrdersV2(_response));
        });
    }

    protected processMyOrdersV2(response: Response): Promise<OrderWithRecipesAndExtras[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrderWithRecipesAndExtras[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderWithRecipesAndExtras[] | null>(<any>null);
    }

    singularSalesOrderForecast(targetWeek: Date, subscriptionNumber: string | null, promoCode: string | null | undefined): Promise<SingleOrderWithRecipesAndExtras | null> {
        let url_ = this.baseUrl + "/account/orders/order?";
        if (targetWeek === undefined || targetWeek === null)
            throw new Error("The parameter 'targetWeek' must be defined and cannot be null.");
        else
            url_ += "targetWeek=" + encodeURIComponent(targetWeek ? "" + targetWeek.toJSON() : "") + "&"; 
        if (subscriptionNumber === undefined)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        else
            url_ += "subscriptionNumber=" + encodeURIComponent("" + subscriptionNumber) + "&"; 
        if (promoCode !== undefined)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSingularSalesOrderForecast(_response));
        });
    }

    protected processSingularSalesOrderForecast(response: Response): Promise<SingleOrderWithRecipesAndExtras | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SingleOrderWithRecipesAndExtras>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SingleOrderWithRecipesAndExtras | null>(<any>null);
    }

    skipDelivery(request: SkipDeliveryRequest | null): Promise<LegacyOrdersResponse | null> {
        let url_ = this.baseUrl + "/account/orders/skipdelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSkipDelivery(_response));
        });
    }

    protected processSkipDelivery(response: Response): Promise<LegacyOrdersResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <LegacyOrdersResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LegacyOrdersResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegacyOrdersResponse | null>(<any>null);
    }

    unSkipDelivery(subscriptionId: number, week: Week): Promise<LegacyOrdersResponse | null> {
        let url_ = this.baseUrl + "/account/orders/unskipdelivery?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(week);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnSkipDelivery(_response));
        });
    }

    protected processUnSkipDelivery(response: Response): Promise<LegacyOrdersResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <LegacyOrdersResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LegacyOrdersResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegacyOrdersResponse | null>(<any>null);
    }

    saveRecipeSelection(request: SaveRecipeSelectionRequest | null): Promise<RecipeSelectionResponse | null> {
        let url_ = this.baseUrl + "/account/orders/recipeselection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveRecipeSelection(_response));
        });
    }

    protected processSaveRecipeSelection(response: Response): Promise<RecipeSelectionResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <SaveRecipeSelectionRequest>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeSelectionResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeSelectionResponse | null>(<any>null);
    }

    /**
     * @return OK
     */
    getSubscriptionCostPreview(week: Date, request: CostPreviewRequestBody | null): Promise<CostPreviewResponse | null> {
        let url_ = this.baseUrl + "/account/orders/cost/calculate?";
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined and cannot be null.");
        else
            url_ += "week=" + encodeURIComponent(week ? "" + week.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubscriptionCostPreview(_response));
        });
    }

    protected processGetSubscriptionCostPreview(response: Response): Promise<CostPreviewResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CostPreviewResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CostPreviewResponse | null>(<any>null);
    }

    getLegacySubscriptionState(): Promise<LegacyOrdersPageStates | null> {
        let url_ = this.baseUrl + "/account/orders/state";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLegacySubscriptionState(_response));
        });
    }

    protected processGetLegacySubscriptionState(response: Response): Promise<LegacyOrdersPageStates | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LegacyOrdersPageStates>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LegacyOrdersPageStates | null>(<any>null);
    }

    getAddExtraLinks(): Promise<AddExtraLink[] | null> {
        let url_ = this.baseUrl + "/account/orders/addExtraLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAddExtraLinks(_response));
        });
    }

    protected processGetAddExtraLinks(response: Response): Promise<AddExtraLink[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddExtraLink[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddExtraLink[] | null>(<any>null);
    }

    /**
     * @return OK
     */
    getProductsGroupedForMarketing(): Promise<ProductGroupResponse[] | null> {
        let url_ = this.baseUrl + "/account/orders/getProductGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProductsGroupedForMarketing(_response));
        });
    }

    protected processGetProductsGroupedForMarketing(response: Response): Promise<ProductGroupResponse[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductGroupResponse[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductGroupResponse[] | null>(<any>null);
    }

    /**
     * @return OK
     */
    getFilters(productSku: string | null, week: Date): Promise<FiltersResponse | null> {
        let url_ = this.baseUrl + "/account/orders/getFilters?";
        if (productSku === undefined)
            throw new Error("The parameter 'productSku' must be defined.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&"; 
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined and cannot be null.");
        else
            url_ += "week=" + encodeURIComponent(week ? "" + week.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFilters(_response));
        });
    }

    protected processGetFilters(response: Response): Promise<FiltersResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FiltersResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FiltersResponse | null>(<any>null);
    }
}

export interface IRateRecipeAccountClient {
    myRatings(deliveryWeeksBack: number | undefined): Promise<RateRecipeResponse | null>;
    rate(rateRecipeRequest: RateRecipeRequest | null): Promise<RateRecipeResponse | null>;
}

export class RateRecipeAccountClient extends BaseClient implements IRateRecipeAccountClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    myRatings(deliveryWeeksBack: number | undefined): Promise<RateRecipeResponse | null> {
        let url_ = this.baseUrl + "/account/rating?";
        if (deliveryWeeksBack === null)
            throw new Error("The parameter 'deliveryWeeksBack' cannot be null.");
        else if (deliveryWeeksBack !== undefined)
            url_ += "deliveryWeeksBack=" + encodeURIComponent("" + deliveryWeeksBack) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMyRatings(_response));
        });
    }

    protected processMyRatings(response: Response): Promise<RateRecipeResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RateRecipeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RateRecipeResponse | null>(<any>null);
    }

    rate(rateRecipeRequest: RateRecipeRequest | null): Promise<RateRecipeResponse | null> {
        let url_ = this.baseUrl + "/account/rating/rate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rateRecipeRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRate(_response));
        });
    }

    protected processRate(response: Response): Promise<RateRecipeResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RateRecipeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RateRecipeResponse | null>(<any>null);
    }
}

export interface ICampaignClient {
    loadCampaignModal(campaignCode: string): Promise<CampaignGroupDto | null>;
    getCampaignProgression(): Promise<EnrolledCampaignDto | null>;
    getCampaignPromotionBanner(): Promise<EligibleCampaignDto | null>;
    joinCampaign(command: JoinCampaignCommandBody | null): Promise<CampaignJoinResponse | null>;
}

export class CampaignClient extends BaseClient implements ICampaignClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    loadCampaignModal(campaignCode: string): Promise<CampaignGroupDto | null> {
        let url_ = this.baseUrl + "/account/campaign/{campaignCode}";
        if (campaignCode === undefined || campaignCode === null)
            throw new Error("The parameter 'campaignCode' must be defined.");
        url_ = url_.replace("{campaignCode}", encodeURIComponent("" + campaignCode)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadCampaignModal(_response));
        });
    }

    protected processLoadCampaignModal(response: Response): Promise<CampaignGroupDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CampaignGroupDto>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CampaignGroupDto | null>(<any>null);
    }

    getCampaignProgression(): Promise<EnrolledCampaignDto | null> {
        let url_ = this.baseUrl + "/account/campaign/progression";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCampaignProgression(_response));
        });
    }

    protected processGetCampaignProgression(response: Response): Promise<EnrolledCampaignDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EnrolledCampaignDto>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnrolledCampaignDto | null>(<any>null);
    }

    getCampaignPromotionBanner(): Promise<EligibleCampaignDto | null> {
        let url_ = this.baseUrl + "/account/campaign/promotion-banner";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCampaignPromotionBanner(_response));
        });
    }

    protected processGetCampaignPromotionBanner(response: Response): Promise<EligibleCampaignDto | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EligibleCampaignDto>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EligibleCampaignDto | null>(<any>null);
    }

    joinCampaign(command: JoinCampaignCommandBody | null): Promise<CampaignJoinResponse | null> {
        let url_ = this.baseUrl + "/account/campaign/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processJoinCampaign(_response));
        });
    }

    protected processJoinCampaign(response: Response): Promise<CampaignJoinResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CampaignJoinResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CampaignJoinResponse | null>(<any>null);
    }
}

export interface IRecipesClient {
    recipesPerWeek(subscriptionId: number, weekStarting: Date): Promise<RecipeSelectionResponse | null>;
    /**
     * @param recipeId (optional) 
     * @return The recipe details
     * @deprecated
     */
    loadRecipeDetails(recipeNumber: string, versionNumber: string, partition: string, week: Date, recipeId: number | null | undefined): Promise<RecipeDetailResponse | null>;
    /**
     * @return The recipe details
     */
    loadRecipeDetailsV2(recipeNumber: string, versionNumber: string, partition: string, week: Date): Promise<RecipeResponse | null>;
}

export class RecipesClient extends BaseClient implements IRecipesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    recipesPerWeek(subscriptionId: number, weekStarting: Date): Promise<RecipeSelectionResponse | null> {
        let url_ = this.baseUrl + "/account/recipes?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&"; 
        if (weekStarting === undefined || weekStarting === null)
            throw new Error("The parameter 'weekStarting' must be defined and cannot be null.");
        else
            url_ += "weekStarting=" + encodeURIComponent(weekStarting ? "" + weekStarting.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRecipesPerWeek(_response));
        });
    }

    protected processRecipesPerWeek(response: Response): Promise<RecipeSelectionResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeSelectionResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeSelectionResponse | null>(<any>null);
    }

    /**
     * @param recipeId (optional) 
     * @return The recipe details
     * @deprecated
     */
    loadRecipeDetails(recipeNumber: string, versionNumber: string, partition: string, week: Date, recipeId: number | null | undefined): Promise<RecipeDetailResponse | null> {
        let url_ = this.baseUrl + "/account/recipes/detail/{recipeNumber}/{versionNumber}/{partition}?";
        if (recipeNumber === undefined || recipeNumber === null)
            throw new Error("The parameter 'recipeNumber' must be defined.");
        url_ = url_.replace("{recipeNumber}", encodeURIComponent("" + recipeNumber)); 
        if (versionNumber === undefined || versionNumber === null)
            throw new Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber)); 
        if (partition === undefined || partition === null)
            throw new Error("The parameter 'partition' must be defined.");
        url_ = url_.replace("{partition}", encodeURIComponent("" + partition)); 
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined and cannot be null.");
        else
            url_ += "week=" + encodeURIComponent(week ? "" + week.toJSON() : "") + "&"; 
        if (recipeId !== undefined)
            url_ += "recipeId=" + encodeURIComponent("" + recipeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadRecipeDetails(_response));
        });
    }

    protected processLoadRecipeDetails(response: Response): Promise<RecipeDetailResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeDetailResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDetailResponse | null>(<any>null);
    }

    /**
     * @return The recipe details
     */
    loadRecipeDetailsV2(recipeNumber: string, versionNumber: string, partition: string, week: Date): Promise<RecipeResponse | null> {
        let url_ = this.baseUrl + "/account/recipes/detailv2/{recipeNumber}/{versionNumber}/{partition}?";
        if (recipeNumber === undefined || recipeNumber === null)
            throw new Error("The parameter 'recipeNumber' must be defined.");
        url_ = url_.replace("{recipeNumber}", encodeURIComponent("" + recipeNumber)); 
        if (versionNumber === undefined || versionNumber === null)
            throw new Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber)); 
        if (partition === undefined || partition === null)
            throw new Error("The parameter 'partition' must be defined.");
        url_ = url_.replace("{partition}", encodeURIComponent("" + partition)); 
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined and cannot be null.");
        else
            url_ += "week=" + encodeURIComponent(week ? "" + week.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadRecipeDetailsV2(_response));
        });
    }

    protected processLoadRecipeDetailsV2(response: Response): Promise<RecipeResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeResponse | null>(<any>null);
    }
}

export interface IUserExperimentClient {
    getExperimentGroup(): Promise<string | null>;
}

export class UserExperimentClient extends BaseClient implements IUserExperimentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    getExperimentGroup(): Promise<string | null> {
        let url_ = this.baseUrl + "/account/information/experimentgroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExperimentGroup(_response));
        });
    }

    protected processGetExperimentGroup(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }
}

export interface IFeaturesClient {
    getAccountFeatures(): Promise<AccountFeatures | null>;
}

export class FeaturesClient extends BaseClient implements IFeaturesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    getAccountFeatures(): Promise<AccountFeatures | null> {
        let url_ = this.baseUrl + "/getFeatures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccountFeatures(_response));
        });
    }

    protected processGetAccountFeatures(response: Response): Promise<AccountFeatures | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountFeatures>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountFeatures | null>(<any>null);
    }
}

export interface IHolidayClient {
    getCustomerAddressHolidayInformation(): Promise<GetCustomerAddressHolidayInformationResponse | null>;
    cancelCustomerHolidayAddress(): Promise<FileResponse | null>;
    createCustomerAddressHoliday(command: CreateCustomerAddressHolidayCommand | null): Promise<FileResponse | null>;
    getNextForecastDeliveryDateForSlot(deliverySlotId: number): Promise<Date>;
    getNextForecastDeliveryOnCancellation(): Promise<Date>;
    previewCustomerAddressHoliday(query: PreviewCustomerAddressHolidayQuery | null): Promise<GetCustomerAddressHolidayPreviewResponse | null>;
}

export class HolidayClient extends BaseClient implements IHolidayClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    getCustomerAddressHolidayInformation(): Promise<GetCustomerAddressHolidayInformationResponse | null> {
        let url_ = this.baseUrl + "/account/holiday/customerAddressHoliday";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomerAddressHolidayInformation(_response));
        });
    }

    protected processGetCustomerAddressHolidayInformation(response: Response): Promise<GetCustomerAddressHolidayInformationResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetCustomerAddressHolidayInformationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCustomerAddressHolidayInformationResponse | null>(<any>null);
    }

    cancelCustomerHolidayAddress(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/account/holiday/customerAddressHoliday";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancelCustomerHolidayAddress(_response));
        });
    }

    protected processCancelCustomerHolidayAddress(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    createCustomerAddressHoliday(command: CreateCustomerAddressHolidayCommand | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/account/holiday/customerAddressHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCustomerAddressHoliday(_response));
        });
    }

    protected processCreateCustomerAddressHoliday(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getNextForecastDeliveryDateForSlot(deliverySlotId: number): Promise<Date> {
        let url_ = this.baseUrl + "/account/holiday/nextForecastDeliveryForSlot?";
        if (deliverySlotId === undefined || deliverySlotId === null)
            throw new Error("The parameter 'deliverySlotId' must be defined and cannot be null.");
        else
            url_ += "deliverySlotId=" + encodeURIComponent("" + deliverySlotId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNextForecastDeliveryDateForSlot(_response));
        });
    }

    protected processGetNextForecastDeliveryDateForSlot(response: Response): Promise<Date> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Date>(<any>null);
    }

    getNextForecastDeliveryOnCancellation(): Promise<Date> {
        let url_ = this.baseUrl + "/account/holiday/nextForecastDeliveryOnCancellation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNextForecastDeliveryOnCancellation(_response));
        });
    }

    protected processGetNextForecastDeliveryOnCancellation(response: Response): Promise<Date> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Date>(<any>null);
    }

    previewCustomerAddressHoliday(query: PreviewCustomerAddressHolidayQuery | null): Promise<GetCustomerAddressHolidayPreviewResponse | null> {
        let url_ = this.baseUrl + "/account/holiday/previewCustomerHolidayAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreviewCustomerAddressHoliday(_response));
        });
    }

    protected processPreviewCustomerAddressHoliday(response: Response): Promise<GetCustomerAddressHolidayPreviewResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetCustomerAddressHolidayPreviewResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCustomerAddressHolidayPreviewResponse | null>(<any>null);
    }
}

export interface UpdateCustomerInfoRequest {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;
    deliveryInstructions?: string | undefined;
    existingPassword?: string | undefined;
    pafId?: number | undefined;
    mobileNumber?: string | undefined;
}

export interface PageModelBase {
    messages?: Message[] | undefined;
    bagSelection?: BagDisplay[] | undefined;
    hasWrittenOffDeliveries?: boolean | undefined;
}

export interface AccountSettings extends PageModelBase {
    myDeals?: MyDealsResponse | undefined;
    customer?: AccountSettingsCustomer | undefined;
    cards?: AccountCreditCard[] | undefined;
    history?: AccountOrder[] | undefined;
    subscriptions?: AccountSubscription[] | undefined;
    availableBags?: AvailableBag[] | undefined;
    createSubscription?: AccountCreateSubscription | undefined;
    lastCancelledSubscription?: LastCancelledSubscription | undefined;
    voucherCode?: ValidatedFieldOfString | undefined;
    referAFriendValueOff?: number | undefined;
    referrals?: Referral[] | undefined;
    enrollableCampaigns?: EnrollableCampaign[] | undefined;
}

export interface MyDealsResponse {
    numberOfRedemptions: number;
    dollarsEarnt: number;
    outstandingCredit: number;
    rafTitle?: string | undefined;
    rafDescriptionTemplate?: string | undefined;
    rafCode?: string | undefined;
    rafAmount: number;
    rafFriendPercentOff: number;
    rafFriendPercentOffDisplay?: string | undefined;
    rafShareText?: string | undefined;
    rafShareUrl?: string | undefined;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    availableRafs?: AvailableRafResponse[] | undefined;
}

export interface AvailableRafResponse {
    amount: number;
    fullName?: string | undefined;
    customerNumber?: string | undefined;
}

export interface AccountSettingsCustomer {
    email?: ValidatedFieldOfString | undefined;
    firstName?: ValidatedFieldOfString | undefined;
    lastName?: ValidatedFieldOfString | undefined;
    mobileNumber?: ValidatedFieldOfString | undefined;
    address?: ValidatedFieldOfString | undefined;
    deliveryInstructions?: ValidatedFieldOfString | undefined;
    referAFriendCode?: string | undefined;
    password?: ValidatedField | undefined;
    existingPassword?: ValidatedField | undefined;
}

export interface ValidatedField {
    valid: boolean;
    message?: string | undefined;
}

export interface ValidatedFieldOfString extends ValidatedField {
    value?: string | undefined;
}

export interface AccountCreditCard {
    id: number;
    isDefault: boolean;
    cardHolderName?: string | undefined;
    cardNumber?: string | undefined;
    cardType?: string | undefined;
    cardExpiry?: string | undefined;
    dateCreated: Date;
    actions?: CreditCardActions[] | undefined;
}

export enum CreditCardActions {
    Remove = 1, 
    MakeDefault = 2, 
}

export interface AccountOrder {
    paidOn?: Day | undefined;
    voucherAmount: number;
    paid: boolean;
    deliveryDate: Day;
    products?: AccountOrderProduct[] | undefined;
    subtotal: number;
    deliverySlot?: string | undefined;
    discounts: number;
    deliveryCost: number;
    total: number;
    paymentDate?: Date | undefined;
}

export interface AccountOrderProduct {
    name?: string | undefined;
    price: number;
    quantity: number;
}

export interface AccountSubscription {
    primaryBagName?: string | undefined;
    id: number;
    subscriptionNumber?: string | undefined;
    primaryBagId: number;
    productOptionSku?: string | undefined;
    brand: Brand;
    primaryFrequency?: ValidatedFieldOfFrequency | undefined;
    deliverySlotId?: ValidatedFieldOfInt32 | undefined;
    cancellationComments?: ValidatedFieldOfString | undefined;
    extras?: KeyValuePairOfInt32AndAccountExtra[] | undefined;
    promos?: AccountPromo[] | undefined;
    deliverySlotDescription?: string | undefined;
    actions?: SubscriptionActions[] | undefined;
    lastDeliveryDay?: Day | undefined;
}

export enum Brand {
    MyFoodBag = 1, 
    BargainBox = 2, 
    FreshStart = 4, 
    ReadyMadeMeals = 8, 
}

export interface ValidatedFieldOfFrequency extends ValidatedField {
    value: Frequency;
}

export enum Frequency {
    Weekly = 1, 
    Fortnightly = 2, 
    OneOff = 3, 
    FourWeekly = 4, 
}

export interface ValidatedFieldOfInt32 extends ValidatedField {
    value: number;
}

export interface KeyValuePairOfInt32AndAccountExtra {
    key: number;
    value?: AccountExtra | undefined;
}

export interface AccountExtra {
    optionId: number;
    productName?: string | undefined;
    description?: string | undefined;
    frequency: Frequency;
    quantity: number;
    price: number;
    deliveryPrice: number;
    totalPrice: number;
    sku?: string | undefined;
}

export interface AccountPromo {
    valueOff: number;
    valueOffType?: string | undefined;
    promoCode?: string | undefined;
    extra?: AccountExtra | undefined;
    extraDescription?: string | undefined;
    description?: string | undefined;
}

export enum SubscriptionActions {
    Default = 0, 
    EditSubscription = 1, 
    CancelSubscription = 2, 
    RestartSubscription = 3, 
    StartNewSubscription = 4, 
}

export interface AvailableBag {
    bagName?: string | undefined;
    bagId: number;
    itemNumber?: string | undefined;
    frequencies?: Frequency[] | undefined;
    availableExtras?: { [key: string] : AvailableExtra; } | undefined;
    webSortOrder: number;
    numberOfPeopleToFeed: number;
    brand: Brand;
}

export interface AvailableExtra {
    id: number;
    sku?: string | undefined;
    description?: string | undefined;
    imageSet?: ResponsiveImageSet | undefined;
    frequency: Frequency;
}

export interface ResponsiveImageSet {
    small?: string | undefined;
    medium?: string | undefined;
    large?: string | undefined;
}

export interface AccountCreateSubscription {
    id: number;
    primaryBagId: number;
    primaryFrequency?: ValidatedFieldOfFrequency | undefined;
    firstDeliveryDateId?: ValidatedFieldOfNullableOfInt64 | undefined;
    hasCreditCards?: ValidatedField | undefined;
    address?: ValidatedFieldOfString | undefined;
    deliveryInstructions?: ValidatedFieldOfString | undefined;
    promoCode?: ValidatedFieldOfString | undefined;
    extras?: { [key: string] : AccountExtra; } | undefined;
}

export interface ValidatedFieldOfNullableOfInt64 extends ValidatedField {
    value?: number | undefined;
}

export interface LastCancelledSubscription {
    primaryBagId: number;
    primaryFrequency: Frequency;
    primaryBagName?: string | undefined;
    productOptionSku?: string | undefined;
}

export interface Referral {
    name?: string | undefined;
    amountOff: number;
    isConsumed: boolean;
    consumptionDate?: Week | undefined;
    referringDeliveryAllocationId: number;
}

export interface EnrollableCampaign {
    campaignGroupName?: string | undefined;
    campaignCodes?: string[] | undefined;
    bannerUrlSmall?: string | undefined;
    bannerUrlMedium?: string | undefined;
    bannerUrlLarge?: string | undefined;
    optionIdWhitelist?: number[] | undefined;
    skuWhitelist?: string[] | undefined;
    isPromoted: boolean;
}

export interface Message {
    title?: string | undefined;
    text?: string | undefined;
    variant: MessageVariant;
    action?: MessageActionDto | undefined;
    secondaryAction?: MessageActionDto | undefined;
    tertiaryAction?: MessageActionDto | undefined;
}

export enum MessageVariant {
    Info = 0, 
    Success = 1, 
    Warning = 2, 
    Danger = 3, 
}

export interface MessageActionDto {
    label?: string | undefined;
    attribute?: any | undefined;
    identifier: MessageAction;
}

export enum MessageAction {
    AddCreditCard = 0, 
    PayAndSaveCard = 1, 
    PayWithoutSavingCard = 2, 
    PayWithDefaultCard = 3, 
}

export interface BagDisplay {
    name?: string | undefined;
    id: number;
    sku?: string | undefined;
    itemNumber?: string | undefined;
    price: number;
    serves?: string | undefined;
    dateTimeStarting: Date;
    weekStarting: Week;
    numberOfPeopleToFeed: number;
    brand: Brand;
    recipeSelectionMode: RecipeSelectionMode;
}

export enum RecipeSelectionMode {
    None = 0, 
    Single = 1, 
    Multiple = 2, 
}

export interface AddressSuggestion {
    pafId: number;
    fullAddress?: string | undefined;
}

export interface AddressValidationRequest {
    addressSuggestionId: number;
}

export interface ValidateAddressResponseDto {
    addressId: number;
    isValid: boolean;
    errorMessage?: string | undefined;
}

export interface ValidateAddressRequest {
    pafId: number;
}

export interface CancelSubscriptionModel extends PageModelBase {
    subscriptionId: number;
    bagName?: string | undefined;
    numberOfPeopleToFeed?: number | undefined;
    suggestedBagId?: number | undefined;
}

export interface SubscriptionDTO {
    posmSku?: string | undefined;
    subscriptionNumber?: string | undefined;
    subscriptionId: number;
    frequency: Frequency;
    status: SubscriptionStatus;
    primaryOptionSku?: string | undefined;
    primaryOptionName?: string | undefined;
    primarySkuNumberOfNights: number;
}

export enum SubscriptionStatus {
    Active = 1, 
    Paused = 2, 
    Cancelling = 3, 
    Cancelled = 4, 
    Pending = 5, 
}

export interface CreateSubscriptionRequest {
    firstDeliveryDateId: number;
    primaryBagId: number;
    productOptionSku?: string | undefined;
    primaryFrequency: Frequency;
    extras?: { [key: string] : ExtraRequest; } | undefined;
    pafId?: number | undefined;
    deliveryInstructions?: string | undefined;
    promoCode?: string | undefined;
}

export interface ExtraRequest {
    optionId: number;
    frequency: Frequency;
    quantity: number;
}

export interface AccountCreateSubscriptionRequestBody {
    deliveryDateId: number;
    sku?: string | undefined;
    promoCode?: string | undefined;
    frequency: Frequency2;
    overrideDeliverySlotId?: number | undefined;
    addressId?: number | undefined;
    deliveryInstructions?: string | undefined;
    extras?: ExtrasItemRequestBody[] | undefined;
    selections?: ChoiceSelectionsRequestBody[] | undefined;
}

export enum Frequency2 {
    Weekly = 1, 
    Fortnightly = 2, 
    OneOff = 3, 
    FourWeekly = 4, 
}

export interface ExtrasItemRequestBody {
    sku?: string | undefined;
    quantity: number;
    frequency: Frequency2;
    addOnToRecipeNumbers?: string[] | undefined;
    deliveryWeek?: Date | undefined;
}

export interface ChoiceSelectionsRequestBody {
    categoryCode?: string | undefined;
    quantity: number;
}

export interface CodeValidationResponse {
    discount?: PromoDto | undefined;
    validationErrors?: string[] | undefined;
}

export interface PromoDto {
    code?: string | undefined;
    message?: string | undefined;
    discountType: DiscountType;
    benefits?: BenefitDto[] | undefined;
    promoGroupId: number;
    forNewOrReturningCustomers: boolean;
    validForProducts?: ProductSummary[] | undefined;
    redeemableFrom: Date;
    redeemableTo: Date;
    bannerUrlSmall?: string | undefined;
    bannerUrlMedium?: string | undefined;
    bannerUrlLarge?: string | undefined;
}

export enum DiscountType {
    Promo = 0, 
    RaF = 1, 
    PromoGroup = 2, 
}

export interface BenefitDto {
    benefitType: BenefitType;
    amount: number;
    message?: string | undefined;
    product?: ProductSummary | undefined;
    consumableFrom: Date;
    consumableTo?: Date | undefined;
    addProductBenefits?: AddProductBenefitDto[] | undefined;
    priceBenefits?: PriceBenefitDto[] | undefined;
}

export enum BenefitType {
    ValueOff = 0, 
    PercentageOff = 1, 
    FixedPrice = 2, 
}

export interface ProductSummary {
    name?: string | undefined;
    productOptionName?: string | undefined;
    productName?: string | undefined;
    sku?: string | undefined;
    itemNumber?: string | undefined;
    numberOfPlates?: number | undefined;
    totalPrice: number;
    deliveryPrice?: number | undefined;
}

export interface AddProductBenefitDto {
    product?: ProductSummary | undefined;
    overridePrice: number;
}

export interface PriceBenefitDto {
    benefitType: BenefitType;
    benefitValue: number;
    selector?: string | undefined;
    productSelectorType: ProductSelectorType;
}

export enum ProductSelectorType {
    All = 0, 
    Sku = 1, 
    Collection = 2, 
    PrimaryCollection = 3, 
    KitchenCollection = 4, 
    GourmetMeal = 5, 
}

export interface ProductAndRecipeDetailsResponse {
    sku?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    badges?: string[] | undefined;
    numberOfPeopleToFeed?: string | undefined;
    imageUrl?: string | undefined;
    additionalInformationUrl?: string | undefined;
    retailPrice: number;
    canRateRecipe: boolean;
    defaultFrequency: Frequency2;
    availableFrequencies?: Frequency2[] | undefined;
    isDemandLocked: boolean;
    pricing?: ProductPricingResponse | undefined;
    recipes?: RecipeResponse2[] | undefined;
    recipeDetails?: RecipeResponse2 | undefined;
}

export interface ProductPricingResponse {
    listPrice: ItemDisplayPriceResponse;
    salePrice: SaleDisplayPriceResponse;
    hasDiscount: boolean;
}

export interface ItemDisplayPriceResponse {
    itemPrice: number;
    deliveryPrice: number;
    totalPrice: number;
    serves: number;
    itemPricePerServe: number;
    totalPricePerServe: number;
}

export interface SaleDisplayPriceResponse {
    itemPrice: number;
    deliveryPrice: number;
    totalPrice: number;
    serves: number;
    itemPricePerServe: number;
    totalPricePerServe: number;
    hasDiscount: boolean;
    discountSource: DiscountSource;
    promoCodeApplied?: string | undefined;
}

export enum DiscountSource {
    None = 0, 
    Other = 1, 
    CustomerPerpetualDiscount = 2, 
    PromoCode = 3, 
}

export interface RecipeResponse2 {
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    allergens?: string[] | undefined;
    allergensContains?: string[] | undefined;
    allergensMayContain?: string[] | undefined;
    composition?: string | undefined;
    ingredientGroups?: IngredientGroupResponse[] | undefined;
    numberOfServes?: string | undefined;
    readyInTime?: number | undefined;
    badge?: string | undefined;
    tags?: string[] | undefined;
    description?: string | undefined;
    sortOrder?: number | undefined;
    type?: string | undefined;
    categoryCode?: string | undefined;
    imageUrl?: string | undefined;
    brand?: string | undefined;
    subtitle?: string | undefined;
    title?: string | undefined;
    recipeDocumentId?: string | undefined;
    steps?: StepResponse[] | undefined;
    nutritionalInformation?: NutritionResponse[] | undefined;
    surcharge?: RecipePricingResponse2 | undefined;
    recipeCardStyleName?: string | undefined;
    maximumQuantity: number;
    consumption?: string | undefined;
    recipeId?: string | undefined;
    version?: string | undefined;
    partitionKey?: string | undefined;
}

export interface IngredientGroupResponse {
    name?: string | undefined;
    ingredients?: IngredientResponse[] | undefined;
}

export interface IngredientResponse {
    ingredientType: IngredientType;
    description?: string | undefined;
    allergensContains?: string | undefined;
    allergensMayContain?: string | undefined;
}

export enum IngredientType {
    Other = 0, 
    Staple = 1, 
    Shared = 2, 
}

export interface StepResponse {
    number: number;
    heading?: string | undefined;
    method?: string | undefined;
}

export interface NutritionResponse {
    code?: string | undefined;
    label?: string | undefined;
    value?: number | undefined;
    unit?: string | undefined;
}

export interface RecipePricingResponse2 {
    listPrice?: ItemDisplayPriceResponse | undefined;
    salePrice?: SaleDisplayPriceResponse | undefined;
    hasDiscount: boolean;
}

export interface RecipeBagDisplayPayload {
    optionId: number;
    subscriptionId?: number | undefined;
}

export interface RecipesForWeek {
    deliveryDate: Day;
    recipes: Recipe[];
}

export interface Recipe {
    id: string;
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    name: string;
    imageUrl?: string | undefined;
    readyInTime?: number | undefined;
    recipeUrl?: string | undefined;
    quantity?: number | undefined;
    unitSurcharge?: number | undefined;
}

export interface UpdateSubscriptionRequest {
    id: number;
    deliverySlotId?: number | undefined;
    primaryBagId?: number | undefined;
    primaryFrequency?: Frequency | undefined;
    extras?: KeyValuePairOfInt32AndExtraRequest[] | undefined;
}

export interface KeyValuePairOfInt32AndExtraRequest {
    key: number;
    value?: ExtraRequest | undefined;
}

export interface CancelSubscriptionRequest {
    subscriptionId: number;
    lastDeliveryDateId?: number | undefined;
    cancellationReason?: string | undefined;
    cancellationComments?: string | undefined;
    wouldConsiderReturning?: boolean | undefined;
}

export interface AccountCancelSubscriptionRequestBody {
    customerNumber?: string | undefined;
    customerMessageTriggerId: number;
    lastDeliveryDateId?: number | undefined;
    cancellationComments?: string | undefined;
    cancellationReason?: string | undefined;
    wouldConsiderReturning?: boolean | undefined;
}

export interface CancelSubscriptionResponse {
}

export interface DeliveryDate {
    id: number;
    description?: string | undefined;
    deliverySlotId: number;
    date: Date;
    weekStarting: Date;
}

export interface DeliverySlot {
    id: number;
    description?: string | undefined;
    dayOfWeek: DayOfWeek;
    nextVirtualDeliveryDay: Day;
    nextVirtualDeliveryDateId?: number | undefined;
}

export enum DayOfWeek {
    Sunday = 0, 
    Monday = 1, 
    Tuesday = 2, 
    Wednesday = 3, 
    Thursday = 4, 
    Friday = 5, 
    Saturday = 6, 
}

export interface GetCustomerMessageResponse {
    triggerCode?: string | undefined;
    triggers?: CustomerMessageTriggerWrapperResponse | undefined;
    customerMessages?: CustomerMessageResponse[] | undefined;
}

export interface CustomerMessageTriggerWrapperResponse {
    title?: string | undefined;
    subtitle?: string | undefined;
    customerMessageTriggers?: CustomerMessageTriggerResponse[] | undefined;
}

export interface CustomerMessageTriggerResponse {
    customerMessageTriggerId: number;
    name?: string | undefined;
    primaryCta?: CustomerMessageActionResponse | undefined;
    secondaryCta?: CustomerMessageActionResponse | undefined;
    sortOrder: number;
}

export interface CustomerMessageActionResponse {
    text?: string | undefined;
    url?: string | undefined;
}

export interface CustomerMessageResponse {
    customerMessageId: number;
    title?: string | undefined;
    body?: string | undefined;
    subtitle?: string | undefined;
    imageUrl?: string | undefined;
    eligibleCustomerMessageTriggerIds?: number[] | undefined;
    primaryCta?: CustomerMessageActionResponse | undefined;
    secondaryCta?: CustomerMessageActionResponse | undefined;
    colourScheme?: CustomerMessageColourSchemeResponse | undefined;
    termsAndConditions?: string | undefined;
    internalMarketingDescription?: string | undefined;
    internalPrimaryActionName?: string | undefined;
    internalSecondaryActionName?: string | undefined;
}

export interface CustomerMessageColourSchemeResponse {
    description?: string | undefined;
    backgroundHex?: string | undefined;
    textHex?: string | undefined;
    accentHex?: string | undefined;
}

export interface ApplyPromoCodeRequest {
    id: number;
    primaryBagId: number;
    productOptionSku?: string | undefined;
    promoCode?: string | undefined;
}

export interface Void {
}

export interface AccountUpdateSubscriptionRequestBody {
    sku?: string | undefined;
    promoCode?: string | undefined;
    addressId?: number | undefined;
    deliveryInstructions?: string | undefined;
    deliverySlotId?: number | undefined;
    frequency?: Frequency2 | undefined;
}

export interface AccountUpdatePlanYourWeekRequestBody {
    sku?: string | undefined;
    selections?: ChoiceSelectionsRequestBody[] | undefined;
    extras?: ExtrasItemRequestBody[] | undefined;
    promoCode?: string | undefined;
}

export interface AccountUpdatePlanYourWeekResponse {
    succeeded: boolean;
    errors?: string[] | undefined;
}

export interface AccountValidateProductChangeRequestBody {
    newSku?: string | undefined;
}

export interface AccountValidateProductChangeResponse {
    incompatibleExtras?: AccountSubscriptionExtraResponse[] | undefined;
    remainingExtras?: AccountSubscriptionExtraResponse[] | undefined;
    incompatibleSubscriptionOverrides: boolean;
}

export interface AccountSubscriptionExtraResponse {
    sku?: string | undefined;
    quantity: number;
    productName?: string | undefined;
    price: number;
    imageUrl?: string | undefined;
    frequency: Frequency2;
}

export interface RedeemVoucherRequest {
    voucherCode: string;
}

export interface CustomerResponse {
    name?: string | undefined;
    deliveryInstructions?: string | undefined;
    address?: string | undefined;
}

export interface CustomerProfileResponse {
    customerDetails?: CustomerDetailsDto | undefined;
    subscriptions?: CustomerProfileSubscriptionDto[] | undefined;
}

export interface CustomerDetailsDto {
    customerNumber?: string | undefined;
    address?: AddressDto | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    optOutRecipeCards: boolean;
    customerCredit?: CustomerCreditDto[] | undefined;
    paymentsDue?: PaymentDueDto[] | undefined;
    vouchers?: VoucherDto[] | undefined;
}

export interface AddressDto {
    addressId: number;
    address?: string | undefined;
    deliveryInstructions?: string | undefined;
    pafId?: number | undefined;
    street?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    postcode?: string | undefined;
    deliveryArea?: string | undefined;
    depotCode?: string | undefined;
}

export interface CustomerCreditDto {
    customerNumber?: string | undefined;
    amount: number;
    customerCreditId: number;
    expiryDate: Date;
}

export interface PaymentDueDto {
    amount: number;
    deliveryId: number;
}

export interface VoucherDto {
    totalAmount: number;
    remainingAmount: number;
    voucherCode?: string | undefined;
    expiryDate: Date;
}

export interface CustomerProfileSubscriptionDto {
    subscriptionNumber?: string | undefined;
    productCollectionCode?: string | undefined;
    productName?: string | undefined;
    iconUrl?: string | undefined;
    iconSvgUrl?: string | undefined;
    isActive: boolean;
    deliverySlot?: DeliverySlotDto | undefined;
    hasFlexedDeliveryAddress: boolean;
}

export interface DeliverySlotDto {
    deliverySlotId: number;
    actualDeliveryStartTime: string;
    actualDeliveryEndTime: string;
    deliveryDay: DayOfWeek2;
}

export enum DayOfWeek2 {
    Sunday = 0, 
    Monday = 1, 
    Tuesday = 2, 
    Wednesday = 3, 
    Thursday = 4, 
    Friday = 5, 
    Saturday = 6, 
}

export interface CalendarResponse {
    calendarEntries?: CalendarEntry[] | undefined;
    messages?: Message[] | undefined;
    calendarEnabled: boolean;
}

export interface CalendarEntry {
    week: Week;
    deliveriesForSubscriptions?: DeliveriesForSubscriptions[] | undefined;
    state: WeekState;
    actions?: OrderAction[] | undefined;
    productNames?: string[] | undefined;
    skus?: string[] | undefined;
}

export interface DeliveriesForSubscriptions {
    subscriptionSku?: string | undefined;
    deliveryDateId: number;
}

export enum WeekState {
    None = 0, 
    Partial = 1, 
    All = 2, 
}

export enum OrderAction {
    Skip = 0, 
    Unskip = 1, 
    ChangeDeliveryAddress = 2, 
    ChangeDeliverySlot = 3, 
    SelectMeals = 4, 
    CanChangeBag = 5, 
}

export interface UpdateDeliveryRequest {
    deliveryId: number;
    deliverySlotId: number;
    pafId: number;
    deliveryInstructions?: string | undefined;
}

export interface UpdateDeliveryResponse {
    hasDeliveryIsLockedError: boolean;
    hasDeliveryAddressError: boolean;
    newAddress?: string | undefined;
}

export interface DeliveryResponse extends PageModelBase {
    deliveryId?: ValidatedFieldOfInt64 | undefined;
    deliveryDateId?: ValidatedFieldOfInt64 | undefined;
    deliveryDay: Day;
    availableDeliveryDates?: DeliveryDate[] | undefined;
    productIsSameAsSubscription: boolean;
}

export interface ValidatedFieldOfInt64 extends ValidatedField {
    value: number;
}

export interface ExtraResponse extends PageModelBase {
    subscriptionId: number;
    subscriptionName?: string | undefined;
    subscriptionExtras?: AccountExtra[] | undefined;
    categories?: ExtraCategory[] | undefined;
    extras?: AvailableExtra[] | undefined;
    subscriptionFrequency: Frequency;
}

export interface ExtraCategory {
    productId: number;
    name?: string | undefined;
    productCode?: string | undefined;
    imageSet?: ResponsiveImageSet | undefined;
    extraIds?: number[] | undefined;
    extraSkus?: string[] | undefined;
}

export interface AvailableExtrasResponse {
    extraProductGroups?: ProductGroupWithSkusResponse[] | undefined;
    extras?: ProductSummaryResponse[] | undefined;
}

export interface ProductGroupWithSkusResponse {
    name: string;
    blurb?: string | undefined;
    tag?: string | undefined;
    iconUrl?: string | undefined;
    sortOrder: number;
    skus: SortableSkuResponse[];
}

export interface SortableSkuResponse {
    sortOrder: number;
    sku: string;
}

export interface ProductSummaryResponse {
    name?: string | undefined;
    simpleName?: string | undefined;
    sku: string;
    imageUrl?: string | undefined;
    nights: number;
    people: number;
    totalPrice: number;
    deliveryPrice?: number | undefined;
    pricePerPlate?: number | undefined;
    isDemandLocked: boolean;
    pricing?: ProductPricingResponse | undefined;
    isVisible: boolean;
    flexedSkus?: string[] | undefined;
    flexedSkusPricing?: FlexedSkusPricingResponse[] | undefined;
    availableFrequencies?: Frequency2[] | undefined;
    settings?: ProductCollectionSettingsResponse | undefined;
}

export interface FlexedSkusPricingResponse {
    nights: number;
    sku?: string | undefined;
    flexedPrice: number;
    flexedPricePerPlate: number;
}

export interface ProductCollectionSettingsResponse {
    productCollectionCode?: string | undefined;
    canEditFromSubscription: boolean;
    canPurchaseFromSubscription: boolean;
}

export interface AddExtraRequest {
    subscriptionId: number;
    productOptionId: number;
    frequency: Frequency;
    quantity: number;
}

export interface UpdateExtraRequest extends AddExtraRequest {
    initialProductOptionId: number;
}

export interface RemoveExtraRequest {
    subscriptionId: number;
    productOptionId: number;
}

export interface ProductGroup {
    pageSections?: Section[] | undefined;
    title?: string | undefined;
    subtitle?: string | undefined;
    metadata?: Metadata | undefined;
    relativePath?: Link | undefined;
    productOptions?: ProductOption[] | undefined;
    weeklyRecipes?: ProductRecipesCollection[] | undefined;
    productRecipes?: Image[] | undefined;
    productImages?: Image[] | undefined;
    tag?: Tag | undefined;
    overcomingHesitation?: string[] | undefined;
    id?: string | undefined;
    disclaimer?: string | undefined;
}

export interface Section {
    title?: string | undefined;
}

export interface ProductOptionsCard extends Section {
    cards?: HeroCard[] | undefined;
    id?: string | undefined;
}

export interface HeroCard {
    title?: string | undefined;
    description?: string | undefined;
    image?: Image | undefined;
    id?: string | undefined;
    cardType?: string | undefined;
}

export interface Image {
    name?: string | undefined;
    src?: string | undefined;
    id?: string | undefined;
}

export interface FaqCard extends Section {
    faqs?: Faq[] | undefined;
    id?: string | undefined;
}

export interface Faq {
    question?: string | undefined;
    answer?: string | undefined;
    id?: string | undefined;
}

export interface Metadata {
    title?: string | undefined;
    description?: string | undefined;
    canonicalUrlLink?: Link | undefined;
    id?: string | undefined;
}

export interface Link {
    name?: string | undefined;
    relativePath?: string | undefined;
    absoluteUrl?: string | undefined;
    id?: string | undefined;
}

export interface ProductOption {
    sku?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    price: number;
    image?: Image | undefined;
    overview?: ProductOverview | undefined;
    id?: string | undefined;
    availableFrequency: AvailableFrequency;
    recipeSelectionMode: RecipeSelectionMode;
}

export interface ProductOverview {
    title?: string | undefined;
    content?: string | undefined;
    id?: string | undefined;
}

export enum AvailableFrequency {
    Weekly = 1, 
    Fortnightly = 2, 
    OneOff = 4, 
    FourWeekly = 8, 
}

export interface ProductRecipesCollection {
    productName?: string | undefined;
    sku?: string | undefined;
    optionName?: string | undefined;
    weeklyRecipes?: ProductWeeklyRecipeCollection[] | undefined;
}

export interface ProductWeeklyRecipeCollection {
    day?: string | undefined;
    recipes?: Image[] | undefined;
}

export interface Tag {
    text?: string | undefined;
    color?: Color | undefined;
}

export interface Color {
    hex?: string | undefined;
}

export interface ExtraContentRequest {
    pageSlug: string;
}

export interface AccountProductSummary {
    name?: string | undefined;
    sku?: string | undefined;
    imageUrl?: string | undefined;
    defaultFrequency: Frequency2;
    availableFrequencies?: Frequency2[] | undefined;
    nights: number;
    people: number;
    totalPrice: number;
    pricePerPlate?: number | undefined;
    isDemandLocked: boolean;
}

export interface ExtraDetailResponse {
    name?: string | undefined;
    numberOfServes?: string | undefined;
    imageUrl?: string | undefined;
    description?: string | undefined;
    frequency?: string | undefined;
    price: number;
    isDemandLocked: boolean;
    pricing?: ProductPricingResponse | undefined;
    badges?: string[] | undefined;
    tags?: string[] | undefined;
    recipeDetail?: RecipeDetailResponse | undefined;
    recipeCollection?: RecipeCollectionResponse[] | undefined;
}

export interface RecipeDetailResponse {
    name?: string | undefined;
    description?: string | undefined;
    numberOfServes?: string | undefined;
    readyInTime?: string | undefined;
    badges?: string[] | undefined;
    tags?: string[] | undefined;
    imageUrl?: string | undefined;
    ingredientGroups?: IngredientGroup[] | undefined;
    legends?: string[] | undefined;
    nutritionalInfo?: string[] | undefined;
    steps?: RecipeStep[] | undefined;
    allergens?: string | undefined;
    disclaimer?: string | undefined;
    unitSurcharge?: number | undefined;
}

export interface IngredientGroup {
    name?: string | undefined;
    ingredients?: string[] | undefined;
}

export interface RecipeStep {
    header?: string | undefined;
    detail?: string | undefined;
}

export interface RecipeCollectionResponse {
    id?: string | undefined;
    day?: string | undefined;
    recipes?: RecipeCollectionModelResponse[] | undefined;
}

export interface RecipeCollectionModelResponse {
    id?: string | undefined;
    name?: string | undefined;
    src?: string | undefined;
    rnumber?: string | undefined;
    rversion?: string | undefined;
    partition?: string | undefined;
    rid: number;
}

export interface OrderWithRecipesAndExtras {
    deliveryId?: number | undefined;
    orderKey?: string | undefined;
    deliveryDate?: DeliveryDateResponse | undefined;
    overrideDeliveryDate?: DeliveryDateResponse | undefined;
    originalDeliveryDate?: DeliveryDateResponse | undefined;
    deliveryAddress?: AddressResponse | undefined;
    isSkipped: boolean;
    deliveryStatus?: DeliveryStatus | undefined;
    subscriptionId: number;
    subscriptionNumber?: string | undefined;
    totalCost: number;
    deliveryLines?: DeliveryLineResponse[] | undefined;
    isDeliveryAddressSameAsDefault: boolean;
    isVirtual: boolean;
    isOneOffOrder: boolean;
    isDemandLocked: boolean;
    orderActions?: OrderAction[] | undefined;
    orderState?: OrderActionsResponse | undefined;
    availableRecipes?: RecipeResponse[] | undefined;
    defaultRecipeCategories?: string[] | undefined;
    pricing?: PricingResponse | undefined;
    skipReason: SkipReason;
    isFirstDeliveryForSubscription: boolean;
    isLastDeliveryForSubscription: boolean;
    deliveryOrderDate: Date;
    selectedExtras?: DeliveryLineResponse[] | undefined;
    selectedRecipes?: RecipeResponse[] | undefined;
    productOptionId: number;
    availableFrequency: AvailableFrequency;
    hasAvailableBufferDates: boolean;
    publicHolidayName?: string | undefined;
    notifications?: NotificationResponse[] | undefined;
}

export interface DeliveryDateResponse {
    deliveryDateId: number;
    deliverySlotId: number;
    weekStarting: Date;
    actualDeliveryDate: Date;
    actualDeliveryStartTime: string;
    actualDeliveryEndTime: string;
    availableToDateTime: Date;
    isDisabled: boolean;
    marketingLabel?: string | undefined;
}

export interface AddressResponse {
    addressId: number;
    street?: string | undefined;
    suburb?: string | undefined;
    city?: string | undefined;
    postcode?: string | undefined;
    deliveryInstructions?: string | undefined;
}

export enum DeliveryStatus {
    Ordered = 2, 
    Locked = 3, 
    Delivered = 4, 
}

export interface DeliveryLineResponse {
    deliveryLineType?: string | undefined;
    sku?: string | undefined;
    lineDescription?: string | undefined;
    simpleName?: string | undefined;
    price: number;
    quantity: number;
    displayQuantity: number;
    subTotal: number;
    order: number;
    discounts?: DeliveryDiscountLineResponse[] | undefined;
    recipes?: RecipeResponse[] | undefined;
    requiredSelectionQuantity?: number | undefined;
    recipeSelectionMode: RecipeSelectionMode2;
    maximumSelectionQuantity: number;
    baseSku?: string | undefined;
    isFlexed: boolean;
    imageUrl?: string | undefined;
    isPromotional: boolean;
    isRecurring: boolean;
    extraSource: ExtraLineSource;
    extraFrequency: Frequency2;
    addOnToRecipeNumbers?: string[] | undefined;
}

export interface DeliveryDiscountLineResponse {
    discount: number;
    discountType: DeliveryLineDiscountType;
}

export enum DeliveryLineDiscountType {
    CustomerPerpetualDiscount = 1, 
    PromoDiscount = 2, 
    CustomerBalancePayment = 3, 
    ReferAFriendDiscount = 4, 
    VoucherPayment = 5, 
    SubscriptionOptIn = 6, 
    Migration = 7, 
    CustomerOptIn = 8, 
}

export interface RecipeResponse {
    imageUrl?: string | undefined;
    title: string;
    subtitle: string;
    quantity: number;
    categoryCode?: string | undefined;
    readyInTime?: number | undefined;
    isDemandLocked: boolean;
    recipeNumber: string;
    recipePartition: string;
    recipeVersion: string;
    badge?: string | undefined;
    tags?: string[] | undefined;
    sortOrder?: number | undefined;
    surcharge?: RecipePricingResponse | undefined;
    maximumQuantity: number;
    servingSize: number;
    consumption?: string | undefined;
    validRecipeAddOns?: ValidRecipeAddOnResponse[] | undefined;
    recipeAddOns?: RecipeAddOnResponse[] | undefined;
}

export interface RecipePricingResponse {
    listPrice: ItemDisplayPriceResponse;
    salePrice: SaleDisplayPriceResponse;
    hasDiscount: boolean;
}

export interface ValidRecipeAddOnResponse {
    sku?: string | undefined;
    pricing?: ProductPricingResponse | undefined;
    displayName?: string | undefined;
}

export interface RecipeAddOnResponse {
    sku?: string | undefined;
    displayName?: string | undefined;
    pricing?: ProductPricingResponse | undefined;
    quantity: number;
}

export enum RecipeSelectionMode2 {
    None = 0, 
    Single = 1, 
    Multiple = 2, 
}

export enum ExtraLineSource {
    Other = 0, 
    SubscriptionOptIn = 1, 
    SubscriptionAddOn = 2, 
    CustomerOptIn = 3, 
    SubscriptionPromo = 4, 
}

export interface OrderActionsResponse {
    canSkip?: OrderActionStateResponse | undefined;
    canUnskip?: OrderActionStateResponse | undefined;
    canChangeMeals?: OrderActionStateResponse | undefined;
    canAddExtras?: OrderActionStateResponse | undefined;
    canChangeBag?: OrderActionStateResponse | undefined;
    canChangeDeliveryShipping?: OrderActionStateResponse | undefined;
    canRateRecipes?: OrderActionStateResponse | undefined;
    canRestartSubscription?: OrderActionStateResponse | undefined;
    canApplyNewPromo?: OrderActionStateResponse | undefined;
}

export interface OrderActionStateResponse {
    isValid: boolean;
    effectiveUntilActual?: Date | undefined;
    effectiveUntilDate?: Date | undefined;
}

export interface PricingResponse {
    shipping: number;
    subTotal: number;
    overallTotal: number;
    appliedDiscount?: AppliedDiscountResponse | undefined;
    discounts?: DiscountRollupResponse[] | undefined;
    summary?: PricingLineSummaryDto | undefined;
}

export interface AppliedDiscountResponse {
    discountSource: DiscountSource;
    promoGroupCode?: string | undefined;
    promoCode?: string | undefined;
    hasDiscountApplied: boolean;
}

export interface DiscountRollupResponse {
    name?: string | undefined;
    amount: number;
}

export interface PricingLineSummaryDto {
    primaryLine?: PricingLineDto | undefined;
    upsellLine?: PricingLineDto | undefined;
    flexedLine?: PricingLineDto | undefined;
    extrasLine?: PricingLineDto | undefined;
}

export interface PricingLineDto {
    name?: string | undefined;
    price: number;
}

export enum SkipReason {
    None = 0, 
    ManualUnskip = 1, 
    ManualSkip = 2, 
    OffWeekSkip = 3, 
    HolidaySkip = 4, 
    ExistingDeliveryForOneOff = 5, 
    CustomerWasMigrated = 6, 
    PrimaryProductHasEnded = 7, 
}

export interface NotificationResponse {
    iconUrl?: string | undefined;
    title?: string | undefined;
    message?: string | undefined;
}

export interface SingleOrderWithRecipesAndExtras {
    orderWithRecipesAndExtras?: OrderWithRecipesAndExtras | undefined;
    promo?: BenefitDto | undefined;
    errors?: string[] | undefined;
}

export interface SkipDeliveryRequest {
    subscriptionId: number;
    weekToSkip: Week;
}

export interface LegacyOrdersPageStates extends PageModelBase {
    lastCancelledSubscription?: LastCancelledSubscription | undefined;
    referAFriendAmountOff?: number | undefined;
    accountMerchSection?: AccountMerchSection | undefined;
    isNewCampaignJourneyEnabled?: boolean | undefined;
    lastCancelledProductIsAvailable?: boolean | undefined;
    upcomingDeliveryWeek?: Date | undefined;
    nextAvailableDeliveryDate?: Date | undefined;
}

export interface LegacyOrdersResponse extends LegacyOrdersPageStates {
    customerName: string;
    customerDeliveryInstructions?: string | undefined;
    customerAddress?: string | undefined;
    deliveryDays: DeliveryDay[];
    subscriptionAction: SubscriptionActions;
}

export interface DeliveryDay {
    date: Day;
    order: Order;
}

export interface Order {
    week: Week;
    subscriptionId: number;
    orderKey: string;
    productOptionId: number;
    bagDescription: string;
    deliveryAddress: string;
    isSkipped: boolean;
    isOrdered: boolean;
    isLocked: boolean;
    cost: number;
    actions: OrderAction[];
    recipes: Recipe[];
    deliverySlotId: number;
    timeRangeStart: Time;
    timeRangeEnd: Time;
    extras?: Extra[] | undefined;
    deliveryId?: number | undefined;
    skipValidation?: ValidatedFieldOfString | undefined;
    recipeSelectionMode?: RecipeSelectionMode | undefined;
    deliveryOrderDate: Date;
    availableFrequency: AvailableFrequency;
    deliveryInstructions?: string | undefined;
    isProductSameAsSubscription: boolean;
    hasOverrideDeliveryDate: boolean;
}

export interface Time {
}

export interface Extra {
    key?: string | undefined;
    name: string;
    sku: string;
    quantity: number;
    recipes?: Recipe[] | undefined;
    imageSet?: ResponsiveImageSet | undefined;
}

export interface AccountMerchSection {
    slotName?: string | undefined;
    hyperlink?: string | undefined;
    imageSet?: ResponsiveImageSet | undefined;
    slotName2?: string | undefined;
    hyperlink2?: string | undefined;
    imageSet2?: ResponsiveImageSet | undefined;
    slotType?: MerchSlotType | undefined;
}

export enum MerchSlotType {
    Single = 0, 
    Double = 1, 
}

export interface SaveRecipeSelectionRequest {
    subscriptionId: number;
    week: Week;
    selectedRecipes?: GridRecipe[] | undefined;
}

export interface GridRecipe {
    name?: string | undefined;
    description?: string | undefined;
    imageUrl?: string | undefined;
    recipeCategoryId: number;
    quantity: number;
    protein?: number | undefined;
    sodium?: number | undefined;
    carbohydrateSugar?: number | undefined;
    carbohydrate?: number | undefined;
    saturatedFat?: number | undefined;
    fat?: number | undefined;
    energy?: number | undefined;
    ingredients?: string | undefined;
    allergens?: string | undefined;
    cookTime?: number | undefined;
    numberOfServes?: string | undefined;
    recipeId?: number | undefined;
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
    recipeGroupRecipeId: string;
    sortOrder: number;
    recipeBadgeNames?: string[] | undefined;
    recipeTagNames?: string[] | undefined;
}

export interface RecipeSelectionResponse {
    subscriptionId: number;
    productName?: string | undefined;
    requiredSelectionQuantity: number;
    selectedRecipes?: GridRecipe[] | undefined;
    actualDeliveryDay?: string | undefined;
    isInvalid: boolean;
    recipeSelectionMode: RecipeSelectionMode;
}

export interface CostPreviewRequestBody {
    sku?: string | undefined;
    baseSku?: string | undefined;
    promoCode?: string | undefined;
    selections?: ChoiceSelectionsRequestBody[] | undefined;
    extras?: ExtrasItemRequestBody[] | undefined;
}

export interface CostPreviewResponse {
    pricing: PricingResponse;
    primaryProduct: ProductLineItemResponse;
    shipping?: ProductLineItemResponse | undefined;
    extras?: ProductLineItemResponse[] | undefined;
    notifications?: NotificationResponse[] | undefined;
}

export interface ProductLineItemResponse {
    name?: string | undefined;
    sku?: string | undefined;
    quantity: number;
    price: number;
    subTotal: number;
}

export interface AddExtraLink {
    subscriptionId: number;
    productName?: string | undefined;
}

export interface ProductGroupResponse {
    name?: string | undefined;
    blurb?: string | undefined;
    tag?: string | undefined;
    iconUrl?: string | undefined;
    iconSvgUrl?: string | undefined;
    sortOrder: number;
    productOptions?: ProductSummaryResponse[] | undefined;
}

export interface FiltersResponse {
    recipes?: FiltersRecipeResponse[] | undefined;
    products?: FiltersProductResponse[] | undefined;
}

export interface FiltersRecipeResponse {
    filterCode?: string | undefined;
    filterDisplay?: string | undefined;
    sortOrder: number;
    resultCount: number;
    banner?: RecipeFiltersBannerResponse | undefined;
    items?: RecipeItemResponse[] | undefined;
}

export interface RecipeFiltersBannerResponse {
    heading?: string | undefined;
    extendedDescription?: string | undefined;
    shortDescription?: string | undefined;
    imageUrl?: string | undefined;
    backgroundColour?: string | undefined;
    textColour?: string | undefined;
}

export interface RecipeItemResponse {
    itemNumber?: string | undefined;
    sortOrder: number;
}

export interface FiltersProductResponse {
    filterCode?: string | undefined;
    filterDisplay?: string | undefined;
    sortOrder: number;
    resultCount: number;
    banner?: ProductFiltersBannerResponse | undefined;
    items?: FiltersItemResponse[] | undefined;
}

export interface ProductFiltersBannerResponse {
    heading?: string | undefined;
    extendedDescription?: string | undefined;
    shortDescription?: string | undefined;
    imageUrl?: string | undefined;
    backgroundColour?: string | undefined;
    textColour?: string | undefined;
}

export interface FiltersItemResponse {
    itemNumber?: string | undefined;
    sortOrder: number;
}

export interface RateRecipeResponse extends PageModelBase {
    deliveryRatingDays?: DeliveryRatingDay[] | undefined;
    deliveryWeeksBack: number;
    count: number;
}

export interface DeliveryRatingDay {
    day: Day;
    dateTime: Date;
    deliveryRatings?: DeliveryRatings[] | undefined;
}

export interface DeliveryRatings {
    bagDescription?: string | undefined;
    recipeRatings?: RecipeRating[] | undefined;
}

export interface RecipeRating {
    id: string;
    rating: number;
    name?: string | undefined;
    imageUrl?: string | undefined;
    receipeUrl?: string | undefined;
    comment?: string | undefined;
    recipeId: number;
    recipeNumber?: string | undefined;
    recipeVersion?: string | undefined;
    recipePartition?: string | undefined;
}

export interface RateRecipeRequest {
    comments?: string | undefined;
    rating?: number | undefined;
    recipeGroupRecipeId: string;
    deliveryWeeksBack?: number | undefined;
}

export interface CampaignGroupDto {
    campaigns?: GroupedCampaignDto[] | undefined;
    groupTitle?: string | undefined;
    groupDescription?: string | undefined;
    campaignParticipationStatus: CampaignParticipationStatus;
    campaignGroupProductOptionIds?: number[] | undefined;
    editableSubscriptions?: CustomersEditableSubscriptionsDto[] | undefined;
    enrolmentStart: Date;
    enrolmentEnd?: Date | undefined;
    isPromoted: boolean;
    theme: CampaignTheme;
}

export interface GroupedCampaignDto {
    campaignName?: string | undefined;
    campaignCode: string;
    marketing?: GroupedCampaignMarketingDto | undefined;
    campaignTiers?: CampaignTierDto[] | undefined;
    prizeSelections?: CampaignSelectionDto[] | undefined;
    remainingDeliveryWeeks?: number | undefined;
    campaignSortOrder: number;
}

export interface GroupedCampaignMarketingDto {
    description?: string | undefined;
    claims?: string[] | undefined;
}

export interface CampaignTierDto {
    campaignTierId: number;
    campaignPrizes: CampaignPrizeDto[];
    deliveriesRequired: number;
}

export interface CampaignPrizeDto {
    campaignPrizeId: number;
    name?: string | undefined;
    imageUrl?: string | undefined;
    sku?: string | undefined;
    isSoldOut: boolean;
    promoGroupCode?: string | undefined;
}

export interface CampaignSelectionDto {
    campaignTierId: number;
    campaignPrizeId: number;
}

export enum CampaignParticipationStatus {
    CampaignIsJoinable = 0, 
    CustomerIsInThisCampaign = 1, 
    CampaignCodeIsNotValid = 2, 
    CampaignHasNotStarted = 3, 
    CampaignHasEnded = 4, 
    CampaignIsFull = 5, 
    CustomerIsInSiblingCampaign = 6, 
    CustomerDoesNotHaveActiveSubscription = 7, 
    ProductOptionIsNotWhitelisted = 8, 
    CustomerIsInAnotherCampaign = 9, 
}

export interface CustomersEditableSubscriptionsDto {
    subscriptionId: number;
    subscriptionNumber?: string | undefined;
    productName?: string | undefined;
}

export enum CampaignTheme {
    Standard = 0, 
    TickerTape = 1, 
}

export interface EnrolledCampaignDto {
    campaignName?: string | undefined;
    joinUrl?: string | undefined;
    joinTitle?: string | undefined;
    joinDescription?: string | undefined;
    enrolmentStart: Date;
    enrolmentEnd?: Date | undefined;
    campaignPrizes?: CampaignPrizeSelectionsDto[] | undefined;
    nextPrize?: CampaignPrizeSelectionsDto | undefined;
    progressionText?: string | undefined;
    canChangePrizeSelection: boolean;
    changePrizeUrl?: string | undefined;
    theme: CampaignTheme;
    deliveryWeekStart: Date;
    deliveryWeekEnd?: Date | undefined;
    campaignButtonText?: string | undefined;
    drawerHeader?: string | undefined;
    drawerBody?: string | undefined;
    progressionTowardsNextCampaignPrize?: NextCampaignPrizeProgression | undefined;
}

export interface CampaignPrizeSelectionsDto {
    numberOfDeliveriesRequired: number;
    name?: string | undefined;
    description?: string | undefined;
    imageUrl?: string | undefined;
    promoCode?: string | undefined;
}

export interface NextCampaignPrizeProgression {
    progress: number;
    target: number;
    isProgressIndicatorHidden: boolean;
    delta: number;
    earnedPrize: boolean;
}

export interface EligibleCampaignDto {
    campaignCode: string;
    enrolmentStart: Date;
    enrolmentEnd?: Date | undefined;
    campaignName?: string | undefined;
    joinUrl?: string | undefined;
    joinTitle?: string | undefined;
    joinDescription?: string | undefined;
    imageUrl?: string | undefined;
    imageUrlMedium?: string | undefined;
    imageUrlLarge?: string | undefined;
    isPromoted: boolean;
    theme: CampaignTheme;
}

export interface JoinCampaignCommandBody {
    campaignSelections?: CampaignSelection[] | undefined;
    campaignCode: string;
    firstDeliveryWeek?: Date | undefined;
    isAutoEnrolled: boolean;
}

export interface CampaignSelection {
    campaignTierId: number;
    campaignPrizeId: number;
}

export interface CampaignJoinResponse {
    isValid: boolean;
    errorMessages?: string[] | undefined;
}

export interface AccountFeatures {
    canUnskipDemandLockedDeliveries: boolean;
    enableBufferInAccount: boolean;
    enableSkipPreventionFlexDown: boolean;
    enableFlexUp: boolean;
    enableFlexDown: boolean;
    enableCustomerAddressHoliday: boolean;
    overrideLegacyReactivationFlow: boolean;
    overrideLegacyCancelSubscriptionFlow: boolean;
    dashboardV2: boolean;
    triggerCodes?: string[] | undefined;
    displayUxOptinBanner: boolean;
}

export interface GetCustomerAddressHolidayInformationResponse {
    holidayAddress?: string | undefined;
    defaultAddress?: string | undefined;
    holidayDeliverySlot?: string | undefined;
    firstHolidayDeliveryDate?: Date | undefined;
    lastHolidayDeliveryDate?: Date | undefined;
    lastDeliveryDateToOriginalAddress?: Date | undefined;
    resumingDeliveryDateToDefaultAddress?: Date | undefined;
    holidayDeliveryPeriodMessage?: string | undefined;
}

export interface CreateCustomerAddressHolidayCommand {
    preferredDeliverySlotId: number;
    startDeliveryDate: Date;
    endDeliveryDate: Date;
    addressSuggestionId: number;
}

export interface PreviewCustomerAddressHolidayQuery {
    preferredDeliverySlotId: number;
    selectedStartDeliveryDate: Date;
    selectedEndDeliveryDate: Date;
}

export interface GetCustomerAddressHolidayPreviewResponse {
    defaultAddress?: string | undefined;
    firstHolidayDeliveryDate?: Date | undefined;
    lastHolidayDeliveryDate?: Date | undefined;
    lastDeliveryDateToOriginalAddress?: Date | undefined;
    resumingDeliveryDateToDefaultAddress?: Date | undefined;
    holidayDeliveryPeriodMessage?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}

export type Day = string;

export type Week = string;

// This is used to attach the import by default
// on the core client
export default BaseClient;